const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/Card/CardActionAreaIconHeader.tsx';
import * as React from 'react';
import { ReactNode } from 'react';
import { css } from '@emotion/css';
import { CardActionArea } from '@mui/material';
import { goToDashboard } from 'App/utils/history';
import { useHistory } from 'react-router';

export type Props = {
    children: ReactNode;
};

const cardActionStyle = css`
    width: unset;
    display: flex;
    justify-content: left;
    align-items: center;
    flex: 1;
`;

export const CardActionAreaIconHeader = (props: Props) => {
    const history = useHistory();

    return (
        <CardActionArea className={cardActionStyle} onClick={() => goToDashboard(history)}>
            {props.children}
        </CardActionArea>
    );
};
